<section class="bp" dir="rtl" aria-labelledby="bp-title">
  <header class="bp__head">
    <h2 id="bp-title" class="bp__title"><i class="mdi mdi-chart-bar"></i> ביצועי העסק</h2>
    <div class="bp__filters">
      <div class="bp__seg" role="group" aria-label="תקופה">
        @for (p of periods; track p) {
          <button type="button" [class.bp__seg--on]="p === period" (click)="setPeriod(p)">{{ p }} ימים</button>
        }
      </div>
      <select class="bp__select" aria-label="מודעה" (change)="onAdChange($any($event.target).value)">
        <option value="">כל המודעות</option>
        @for (a of ads; track a.id) { <option [value]="a.id">{{ a.name }}</option> }
      </select>
    </div>
  </header>

  @if (loading) {
    <div class="bp__state"><span class="bp__spinner"></span></div>
  } @else if (failed) {
    <div class="bp__state">לא הצלחנו לטעון את הנתונים. <button type="button" class="bp__link" (click)="load()">נסו שוב</button></div>
  } @else {
    <div class="bp__tiles">
      @for (t of tiles; track t.kind) {
        <div class="bp__tile">
          <span class="bp__tile-label">{{ t.label }}</span>
          <span class="bp__tile-value">{{ total(t.kind) | number }}</span>
          <span class="bp__tile-sub">
            @if (paid(t.kind) > 0) { מתוכן {{ paid(t.kind) | number }} מקידום ממומן } @else { אורגני }
          </span>
          @if (t.hint) { <span class="bp__tile-hint">{{ t.hint }}</span> }
        </div>
      }
    </div>

    @if (hasData) {
      <div class="bp__chart-card">
        <div class="bp__chart-title">פתיחות מודעה לפי יום</div>
        <div class="bp__chart" role="img" [attr.aria-label]="'פתיחות מודעה לפי יום, ' + period + ' ימים'">
          @for (p of series; track p.day; let i = $index) {
            <div class="bp__col" (mouseenter)="hoverIndex = i" (mouseleave)="hoverIndex = null">
              <div class="bp__bar" [style.height.%]="barHeight(p.value)"></div>
              @if (hoverIndex === i) {
                <div class="bp__tip"><b>{{ p.value | number }}</b> פתיחות<br />{{ shortDay(p.day) }}</div>
              }
            </div>
          }
        </div>
        <div class="bp__axis">
          <span>{{ series[0]?.day ? shortDay(series[0].day) : '' }}</span>
          <span>{{ series[series.length - 1]?.day ? shortDay(series[series.length - 1].day) : '' }}</span>
        </div>
      </div>

      @if (report?.ads?.length) {
        <div class="bp__table-wrap">
          <table class="bp__table">
            <thead>
              <tr><th>מודעה</th><th>הופעות</th><th>פתיחות</th><th>חיוג</th><th>פניות</th></tr>
            </thead>
            <tbody>
              @for (a of report!.ads; track a.id) {
                <tr>
                  <td><a [routerLink]="['/single', a.id]">{{ a.name || ('#' + a.id) }}</a></td>
                  <td>{{ a.impression | number }}</td>
                  <td>{{ a.open | number }}</td>
                  <td>{{ a.phone_tap | number }}</td>
                  <td>{{ a.inquiry | number }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    } @else {
      <p class="bp__empty">עדיין אין נתונים לתקופה הזו. הנתונים נאספים מהיום שבו החשבון העסקי פעיל.</p>
    }
  }
</section>
